"use client"

import IconMinus from "@/app/(site)/_components/Atoms/Icons/IconMinus"
import IconPlus from "@/app/(site)/_components/Atoms/Icons/IconPlus"
import { getLangCode } from "@/app/(site)/_utils/misc"
import { t } from "@/translations"
import { GenaralAccordionContent } from "@/types"
import { usePathname } from "next/navigation"
import React from "react"
import {
    AccordionContent,
    AccordionIcon,
    AccordionRoot,
    AccordionTrigger
} from "../../../Atoms/Accordion"
import Heading from "../../../Atoms/Heading"
import PortableTextRenderer from "../../../Atoms/PortableTextRenderer/PortableTextRenderer"
import Text from "../../../Atoms/Text"

type AccordionShippingProps = {
    reviews?: any
    content?: GenaralAccordionContent | undefined
}

const AccordionShipping: React.FC<AccordionShippingProps> = ({
    content
}: AccordionShippingProps) => {
    const langCode = getLangCode(usePathname().split("/")[1]) || ""

    return (
        <AccordionRoot className="border-t-2 border-black" initalState={true}>
            <AccordionTrigger className="grid w-full cursor-pointer grid-cols-2 pb-32 pt-24 md:pb-72">
                {content?.accordionTitle && (
                    <Heading type="accordionHeading" className="text-left">
                        {t(langCode, content.accordionTitle)}
                    </Heading>
                )}
                <div className="flex justify-between">
                    <div>
                        {content?.accordionSubTitle1 && (
                            <Text
                                size="medium"
                                weight="regular"
                                className="hidden md:block"
                            >
                                {content.accordionSubTitle1}
                            </Text>
                        )}
                        {content?.accordionSubTitle2 && (
                            <Text
                                size="medium"
                                weight="regular"
                                className="hidden md:block"
                            >
                                {content.accordionSubTitle2}
                            </Text>
                        )}
                    </div>
                    <AccordionIcon openIcon={<IconMinus />} closeIcon={<IconPlus />} />
                </div>
            </AccordionTrigger>
            <AccordionContent>
                <div className="mb-24 md:mb-72">
                    <PortableTextRenderer content={content?.accordionContext ?? []} />
                </div>
            </AccordionContent>
        </AccordionRoot>
    )
}

export default AccordionShipping
